import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import TpPlatformInvoiceStatusesEnum from '../../../Enums/TpPlatformInvoiceStatusesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class TpPlatformInvoiceSearchParams extends SearchParamsBase {
  initialize() {
    this.ThirdPartySource = '';
    this.Status = '';
    this.BillingPeriod = '';
    // Date bounds default to the indefinite sentinel as STRINGS, not Date objects: this class
    // compares with !== in isThereAnySearchParameter, and two Date instances are never equal.
    // Same shape as ProjectSearchParams.
    this.UseInvoiceDateRange = false;
    this.InvoiceDateFrom = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
    this.InvoiceDateTo = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.indefiniteDateValue());
  }

  ClearAll() {
    this.initialize();
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'ThirdPartySource',
      label: 'Source',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: TpPlatformInvoiceSearchParams.getSourceOptions(),
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: TpPlatformInvoiceSearchParams.getStatusOptions(),
    },
    {
      fieldName: 'BillingPeriod',
      label: 'Billing Period',
      className: 'col-4',
      type: InputTypesEnum.Text,
      tooltipText: 'Matches part of the period, so 2026 returns the whole year and 2026-06 one month.',
    },
    {
      fieldName: 'UseInvoiceDateRange',
      label: 'Use Invoice Date Range',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'InvoiceDateFrom',
      label: 'Invoice Date From',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseInvoiceDateRange,
    },
    {
      fieldName: 'InvoiceDateTo',
      label: 'Invoice Date To',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseInvoiceDateRange,
    },
  ];

  static title = 'Search for Platform Invoices';
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpPlatformInvoiceSearchParams';

  static isThereAnySearchParameter(searchItem) {
    const defaultSearchItem = new TpPlatformInvoiceSearchParams();
    for (const key in searchItem) {
      if (searchItem[key] !== defaultSearchItem[key]) return true;
    }
    return false;
  }

  static getSourceOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      { label: 'Prism', value: 'Prism', disabled: false },
      { label: 'PrismIntl', value: 'PrismIntl', disabled: false },
    ];
  }

  static getStatusOptions() {
    return [
      { label: 'Choose one...', value: '', disabled: false },
      { label: TpPlatformInvoiceStatusesEnum.Pending, value: TpPlatformInvoiceStatusesEnum.Pending, disabled: false },
      {
        label: TpPlatformInvoiceStatusesEnum.Summarized,
        value: TpPlatformInvoiceStatusesEnum.Summarized,
        disabled: false,
      },
      { label: TpPlatformInvoiceStatusesEnum.Ignored, value: TpPlatformInvoiceStatusesEnum.Ignored, disabled: false },
    ];
  }
}
